class HpReasonsSection extends HTMLElement {
  connectedCallback() {
    this._init();
  }

  _init() {
    this._initAccordion();
    this._initModal();
  }

  _initAccordion() {
    this.querySelectorAll('[data-reasons-toggle]').forEach(toggle => {
      toggle.addEventListener('click', () => this._onToggle(toggle));
    });
  }

  _onToggle(toggle) {
    const card = toggle.closest('[data-reasons-card]');
    if (!card) return;
    const isOpen = card.classList.contains('is-open');
    card.classList.toggle('is-open', !isOpen);
    toggle.setAttribute('aria-expanded', String(!isOpen));
  }

  _initModal() {
    const trigger = this.querySelector('[data-reasons-pdf-trigger]');
    const modal = this.querySelector('[data-reasons-modal]');
    if (!trigger || !modal) return;

    this._boundKeydown = this._onKeydown.bind(this, modal);

    trigger.addEventListener('click', e => {
      e.preventDefault();
      this._openModal(modal);
    });

    modal.querySelector('[data-reasons-modal-close]')
      ?.addEventListener('click', () => this._closeModal(modal));

    modal.querySelector('[data-reasons-modal-overlay]')
      ?.addEventListener('click', () => this._closeModal(modal));
  }

  _openModal(modal) {
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', this._boundKeydown);
    modal.querySelector('[data-reasons-modal-close]')?.focus();
  }

  _closeModal(modal) {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', this._boundKeydown);
  }

  _onKeydown(modal, e) {
    if (e.key === 'Escape') this._closeModal(modal);
  }
}

customElements.define('hp-reasons-section', HpReasonsSection);
